module.exports = __webpack_public_path__ + "img/pleasure-icon-7.5aab6b1c.svg";